import { useMemo } from "react";
import type {
  AthleteTargets,
  BodyFigure,
  Exercise,
  TodayGap,
} from "@heraion/shared";
import type { ProgressDeps, StartBuiltSessionInput } from "@heraion/ui";

import { useTodayRestHours } from "./useTodayRestHours";

// PG-1 muscle coverage on top of the self ProgressDeps: the figure, the
// athlete's own targets, and
// AP-9b's «Build today's session» (only when the host can open the logger).
// Progress and the Home coverage widget (HR-11) read the same. Twin of
// apps/mobile/src/progress/useCoverageDeps.ts.
export function useSelfCoverageDeps(
  base: ProgressDeps,
  {
    figure,
    athleteTargets,
    startBuiltSession,
  }: {
    figure: BodyFigure | undefined;
    athleteTargets: AthleteTargets | null;
    /** Absent: no logger to open, so no «Build today's session» link. */
    startBuiltSession?: (input: StartBuiltSessionInput) => unknown;
  },
): ProgressDeps {
  const painMap = base.painMap;
  // The rest the draft's chips save; this card builds with it.
  const [restHours] = useTodayRestHours();
  const onBuildToday = useMemo(
    () =>
      startBuiltSession
        ? (
            gaps: TodayGap[],
            catalog: ReadonlyArray<Exercise>,
            opts?: { bodyweightOnly?: boolean },
          ) => void startBuiltSession({ gaps, catalog, painMap, restHours, ...opts })
        : undefined,
    [startBuiltSession, painMap, restHours],
  );
  return useMemo<ProgressDeps>(
    () => ({ ...base, figure, athleteTargets, onBuildToday }),
    [base, figure, athleteTargets, onBuildToday],
  );
}
